import clsx from 'clsx';
import React from 'react';

export default function ZapierIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 46 47"
      fill="none"
      className={clsx('text-current', className)}
    >
      <rect
        x="0.513672"
        y="0.663086"
        width="45.4158"
        height="45.4158"
        rx="7.49749"
        fill="#FF4F00"
      />
    </svg>
  );
}
